module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['media-post ', _vm.classes]
  }, [(_vm.pieceType(_vm.piece.mediaType) === 'image') ? _c('media-item-image', {
    attrs: {
      "data": _vm.piece
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pieceType(_vm.piece.mediaType) === 'video') ? _c('media-item-video', {
    attrs: {
      "data": _vm.piece
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pieceType(_vm.piece.mediaType) === 'audio') ? _c('media-item-audio', {
    attrs: {
      "data": _vm.piece
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pieceType(_vm.piece.mediaType) === 'link') ? _c('media-item-link', {
    attrs: {
      "data": _vm.piece
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', [_c('router-link', {
    attrs: {
      "to": _vm.linkToPiece
    }
  }, [_vm._v(_vm._s(_vm.piece.title))])], 1), _vm._v(" "), (_vm.piece.description.length > 0) ? _c('markdown-content', {
    attrs: {
      "classes": "content",
      "content": _vm.piece.description
    }
  }) : _vm._e(), _vm._v(" "), _c('footer', [_c('ul', [_c('li', [_c('voting-widget', {
    attrs: {
      "parent-type": "media",
      "parent-id": _vm.piece.id,
      "initial-points": "0"
    }
  })], 1), _vm._v(" "), _c('li', [_c('a', {
    class: ['show-comments', {
      selected: _vm.commentsVisible
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleComments($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.commentCount) + "\n                comments")])]), _vm._v(" "), _c('li', {
    staticClass: "social-sharing"
  }, [_c('i', {
    staticClass: "fab fa-facebook-f",
    on: {
      "click": function($event) {
        _vm.socialShare('facebook')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fab fa-twitter",
    on: {
      "click": function($event) {
        _vm.socialShare('twitter')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fab fa-linkedin-in",
    on: {
      "click": function($event) {
        _vm.socialShare('linkedin')
      }
    }
  })]), _vm._v(" "), (_vm.canEdit) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": _vm.linkToPiece + '/Edit'
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt edit-button"
  })]) : _vm._e()], 1)]), _vm._v(" "), (_vm.commentsVisible) ? _c('section', {
    staticClass: "comments"
  }, [(Object.keys(_vm.piece.comments || {}).length > 0) ? _c('ul', {
    staticClass: "post-comments"
  }, _vm._l((_vm.piece.comments), function(comment) {
    return _c('post-comment', {
      attrs: {
        "comment": comment
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('form', {
    staticClass: "new-comment"
  }, [_c('markdown-editor', {
    attrs: {
      "placeholder": "Add a comment"
    },
    model: {
      value: (_vm.newCommentContent),
      callback: function($$v) {
        _vm.newCommentContent = $$v
      },
      expression: "newCommentContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-row"
  }, [(_vm.postAsOptions.length > 1) ? _c('label', [_c('span', [_vm._v("Post as ")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postAs),
      expression: "postAs"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.postAs = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.postAsOptions), function(postAsOption) {
    return _c('option', {
      domProps: {
        "value": postAsOption.value
      }
    }, [_vm._v(_vm._s(postAsOption.text))])
  }))])]) : _vm._e(), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitComment($event)
      }
    }
  }, [_vm._v("Submit")])])])], 1) : _c('div', [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/Login"
    }
  }, [_vm._v("Log in")]), _vm._v("\n                to reply\n            ")], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-390da914!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/FeedPosts/MediaPost.vue
// module id = 852
// module chunks = 2